import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	paddingLabel: {
		id: 'custom-sites-extensions.link-cards.link-cards-config-panel.styles.padding-label',
		defaultMessage: 'Padding',
		description:
			'A visible text label for the padding section of the link cards config panel that informs the user that they can select either true or false.',
	},
});
